
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/supplier-journal-categories`,
        name: `${prefix}.accounts.supplier-journal-categories.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.supplier-journal-categories.index`,
                PageDescription: "Accounts master data: Supplier journal journal categories",
            },
        },
    },
];
